<script lang="ts" setup>
import OurStaff from "~/components/about/ourStaff.vue";
import StickyNavLinks from "~/components/StickyNavLinks.vue";
import DiversityCulture from "~/components/about/DiversityCulture.vue";
import AbcCares from "~/components/about/AbcCares.vue";
import EnvironmentCare from "~/components/about/EnvironmentCare.vue";
import CustomerTestimonials from "~/components/about/CustomerTestimonials.vue";
import { useUserStore } from "~/store/user";
import { ref } from "vue";

// Data
const tabs: object = {
    ourStaff: "Our Staff",
    diversityAndCulture: "Diversity & Culture",
    abcCares: "ABC Cares",
    environment: "Environment",
    testimonials: "Testimonials",
};

const userState = ref("ga");
const loading = ref(true);

onMounted(async () => {
    userState.value = await useUserStore().fetchUserState();
    loading.value = false;
});
</script>

<template>
    <div>
        <div class="bg-abc-gray flex-row-reverse lg:flex">
            <div
                class="relative flex-1 items-center px-4 pt-10 pb-20 md:px-10 lg:flex lg:px-28 lg:pt-0 lg:pb-0 xl:px-40"
            >
                <div class="flex-1">
                    <H1Heading size="text-3xl md:text-4xl mb-4 md:mb-0">Who We Are</H1Heading>
                    <p>
                        American Book Company (ABC) was created by two educators who saw a need to improve the selection
                        of quality educational resources in the classroom. That vision has driven us to create
                        innovative content that has helped students achieve success in and out of the classroom for over
                        27 years. We pride ourselves in writing books that are accurate, effective, easy-to-read, and
                        engaging for students and teachers alike, across all subjects — Mathematics, English Language
                        Arts, Science, and Social Studies.
                    </p>
                </div>

                <div
                    class="absolute -bottom-10 left-0 w-full text-center text-3xl font-black lg:bottom-auto lg:-left-24 lg:w-auto xl:text-4xl"
                >
                    <div
                        class="mr-4 inline-block rounded-2xl border bg-white px-6 py-4 drop-shadow-sm lg:mr-0 lg:block"
                    >
                        27<span class="text-green-600">&plus;</span>
                        <div class="text-base font-normal">Years in Business</div>
                    </div>
                    <div class="inline-block rounded-2xl border bg-white px-6 py-4 drop-shadow-sm md:mt-8 lg:block">
                        5395
                        <div class="text-base font-normal">Schools Served</div>
                    </div>
                </div>
            </div>
            <div class="max-h-80 flex-none overflow-hidden md:max-h-none lg:w-1/3">
                <NuxtImg
                    src="/images/about/about-us_hero.jpg"
                    alt="About Us Hero"
                    class="mx-auto"
                />
            </div>
        </div>

        <StickyNavLinks
            :tabs="tabs"
            class="mt-8"
        >
            <template #ourStaff>
                <OurStaff class="py-14" />
            </template>
            <template #diversityAndCulture>
                <DiversityCulture />
            </template>
            <template #abcCares>
                <AbcCares class="py-14" />
            </template>
            <template #environment>
                <EnvironmentCare />
            </template>
            <template #testimonials>
                <CustomerTestimonials class="py-14" />
            </template>
        </StickyNavLinks>
    </div>
</template>
